<template>
  <div>
    <CrudList
      title="Modelos"
      storeName="Car_models"
      parentStoreName="Car_brands"
      parentUrlKey="brand_id"
      labelAddNew="Agregar"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      labelBack="Atrás"
      sortable
      :breadcrumbs="[
      {
        text: 'Spots y vehículos',
        disabled: false,
        href: '/admin/cars'
      },
      {
        text: 'Modelos',
        disabled: false,
        href: '#'
      },
    ]"
    >
      <template v-slot:car_picture="{ item }">
        <v-row align="center" justify="center">
          <v-col cols="12">
              <img :src="item.car_picture" alt="" width="150">
          </v-col>
        </v-row>
      </template>
      </CrudList>
    </div>
  </template>

  <script>
    import CrudList from "@/components/Crud/CrudList";

    export default {
      components: {CrudList},
      data: () => ({
        offsetTop: 0,
      }),
      methods: {
        onScroll (e) {
          this.offsetTop = e.target.scrollTop
        },

      },
    };
  </script>
